import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import { localeResources } from "src/locales/index.js";

const DEFAULT_LANG = "en";
const STORAGE_KEY = "SiteLanguage";

function safeGetStoredLanguage() {
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

// Initialize once (module singleton).
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: localeResources.en },
    fa: { translation: localeResources.fa },
  },
  // SSR-safe: always start with the same language on server & client to avoid
  // hydration mismatch, then switch after mount.
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  interpolation: { escapeValue: false },
});

export function syncI18nLanguageFromStorage() {
  if (typeof window === "undefined") return;
  const stored = safeGetStoredLanguage();
  if (stored && stored !== i18n.language) {
    void i18n.changeLanguage(stored);
  }
}

export default i18n;
